import { facetsSerializer } from '@/providers/serializers/facets/facets';
import { http } from '../http';

export class FacetsAPI {

    private static INSTANCE = new FacetsAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace = 'api/admin/v1';

    public createFacets(payload: any) {
        const endpoint = `${this.namespace}/settings/facets`;
        const headers = http.getTokenHeaders();
        return http.post(endpoint, headers, payload).then((response) => {
            return response.status;
        });
    }

    public getFacetsList(tenantId: any = null) {
        let endpoint = `${this.namespace}/settings/facets`;
        if (tenantId) {
            endpoint = endpoint + `?tenantId=${tenantId}`;
        }
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return facetsSerializer.normalizeFacets(response.data);
        });
    }

    public fetchCustomMetadata(endpoint: string) {
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return facetsSerializer.normalizeCustomFacetMetadata(response.data);
        }).catch(() => {
            return [];
        });
    }

}

export const facetsAPI = FacetsAPI.instance;
